import { colorsList } from "../data/colorsList";
import { svgIcons } from "../data/svgIcons";
import { GroupIcon } from "../TheGroups/components/GroupIcon";

export default function MiniButton({
  Icon,
  title,
  onClick,
  color,
  iconColor,
  iconSize = 20,
  style,
  shadow,
  image,
  svg,
  titleColor,
}) {
  // console.log(
  //   "minibutton",
  //   Icon,
  //   title,
  //   onClick,
  //   color,
  //   iconColor,
  //   (iconSize = 20),
  //   style,
  //   shadow,
  //   image,
  //   svg,
  //   titleColor
  // );
  return (
    <table
      cellPadding={0}
      cellSpacing={0}
      style={{
        backgroundColor:
          color === "transparent" ? null : color ?? colorsList.blue,
        cursor: "pointer",
        overflow: "hidden",
        borderRadius: 10, // iconSize,
        paddingRight: title ? 5 : 0,
        boxShadow: shadow ? "3px 3px 6px rgba(0, 0, 0, 0.5)" : null,
        ...style,
      }}
      onClick={onClick}
    >
      <tbody>
        <tr>
          {[!!Icon, !!image, !!svg].includes(true) && (
            <td align="center">
              <div
                style={{
                  position: "relative",
                  width: iconSize,
                  height: iconSize,
                  color: iconColor ?? colorsList.white,
                  padding: !!image ? 0 : 3,
                  paddingRight: !!title || !!image ? 0 : 3,
                }}
              >
                {!!Icon ? (
                  <Icon style={{ fontSize: iconSize, bottom: 0 }} />
                ) : !!image ? (
                  <img
                    src={image.src}
                    style={{
                      position: "relative",
                      userSelect: "none",
                      width: "100%",
                      height: "100%",
                    }}
                    alt={image.alt}
                  />
                ) : (
                  <GroupIcon
                    print={true}
                    id={svg}
                    fill={svgIcons[svg].color}
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  />
                )}
              </div>
            </td>
          )}
          {title && (
            <td>
              <b
                style={{
                  color: titleColor ?? colorsList.white,
                  textWrap: "nowrap",
                  paddingLeft: 5,
                  paddingRight: 5,
                }}
              >
                {title}
              </b>
            </td>
          )}
        </tr>
      </tbody>
    </table>
  );
}
